import 'bootstrap-icons/font/bootstrap-icons.css';
const Footer = () =>{
    return (
        <>
        <div className="container-fluid bg-light shadow mt-3 mt-md-5 mt-sm-5 mt-xs-5">
				<div className="row">
					<div className="col-12 col-md-4 mt-2 mt-md-5 ps-3 ps-md-5">
						<div className="footer-widget">
							<div className="logo">
								<a href="/"> <img src="/assets/images/rklogo.png" alt="logo" className="w-25 h-25"/> </a>
							</div>
							<p className="pt-1 pe-5">Founded in 2021, the company brings together experienced engineers and designers to create innovative, tailored software solutions that support business growth.</p>
							<div className="footer-widget pt-3">
								<a
									href="https://www.facebook.com/profile.php?id=61591039588308"
									className="foote-a1 me-3"
									target="_blank"
									rel="noopener noreferrer"
									aria-label="Facebook"
								>
									<i className="bi bi-facebook fs-4"></i>
								</a>
								<a
									href="https://www.instagram.com/rkinfosyscomp?utm_source=qr"
									className="foote-a1 me-3"
									target="_blank"
									rel="noopener noreferrer"
									aria-label="Instagram"
								>
									<i className="bi bi-instagram fs-4"></i>
								</a>
								<a
									href="https://wa.me/918758444957"
									className="foote-a1 me-3"
									target="_blank"
									rel="noopener noreferrer"
									aria-label="WhatsApp"
								>
									<i className="bi bi-whatsapp fs-4"></i>
								</a>
							</div>
						</div>
					</div>
					<div className="col-12 col-md-4 mt-3 mt-md-5">
						<div className="footer-widget ps-2 ps-md-5">
							<h3 className="foote-a fw-bolder">Quick Links</h3>
							<ul className="links list-unstyled  pt-2">
								<li><a href="/" className="text-decoration-none foote-a1 pt-2 fw-bold mb-3">Home</a></li>
								<li><a href="/about" className="text-decoration-none foote-a1 pt-2 fw-bold mb-3">About</a></li>
                                <li><a href="/services" className="text-decoration-none foote-a1 pt-2 fw-bold mb-3">Services</a></li>
								<li><a href="/contact" className="text-decoration-none foote-a1 pt-2 fw-bold mb-3">Contact Us</a></li>
							</ul>
						</div>
                        </div>
                        <div className="col-12 col-md-4 mt-3 mt-md-5">
                        <div className="footer-widget ps-2 ps-md-5">
                            <h3 className="foote-a fw-bolder pb-2">Contact Us</h3>
							<div className='mb-3'>
				
							<span className=''><span className='fw-bolder fw-6'>Address  :</span> G-5 Shreemukh Heights, Tighra Road,Opp.Rachana Residency, Navsari. Pincode-396445</span></div>
							<div className='mb-3'><span className='fw-bolder fw-6'>Phone  :</span><span className='ms-2'>8758444957</span></div>
                            <div className='mb-3'><span className='fw-bolder fw-6'>Email :</span><span className='ms-2'>rkinfosys19@gmail.com</span></div>
							<div className='mb-4'><span className='fw-bolder fw-6'>Website :</span><span className='ms-2'>www.rkinfosys.com</span></div>
						</div>
					</div>
				</div>
			</div>
			<div className="container-fluid pb-3 bg-light">
				<div className="copyright text-center border-top">
					<p>  <a href="/" rel="nofollow" target="_blank" className='text-decoration-none foote-a '>2026 © RK Infosys</a> All rights reserved.</p>
				</div>
			</div>
        </>
    )
}
export default Footer;